import { useMediaQuery } from 'react-responsive';
import { SCREEN_BREAKPOINTS } from './media-breakpoints';

export interface ResponsiveLayoutResponse {
  isMobile: boolean;
  isDesktop: boolean;
}

const useResponsiveLayout = (): ResponsiveLayoutResponse => {
  const isDesktop = useMediaQuery({
    minWidth: SCREEN_BREAKPOINTS.M
  });
  return {
    isMobile: !isDesktop,
    isDesktop
  };
};

export default useResponsiveLayout;
